import React from "react";
import { string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Facebook from "../../atoms/icons/social-share/facebook";
import Twitter from "../../atoms/icons/social-share/twitter";
import Telegram from "../../atoms/icons/social-share/telegram";
import Messanger from "../../atoms/icons/social-share/messanger";
import Whatsapp from "../../atoms/icons/social-share/whatsapp";
import Comment from "../../atoms/icons/social-share/comment";

import translate from "../../translate";

import "./social-share-links.m.css";

const SocialShareLinks = ({ whatsappUrl, fbUrl, twitterUrl, title, url, publisherUrl, publisherName }) => {
  const fullUrl = `${publisherUrl}/${url}`;

  return (
    <ul styleName="social-share-links" className="social-share-links">
      <li className="facebook-share-icon">
        <a data-social-media-type="facebook" href={fbUrl} target="_blank" rel="nofollow">
          <Facebook text={translate(publisherName, "share")} />
        </a>
      </li>
      <li className="twitter-share-icon">
        <a data-social-media-type="twitter" href={twitterUrl} target="_blank" rel="nofollow">
          <Twitter text={translate(publisherName, "share")} />
        </a>
      </li>
      <li className="whatsapp-share-icon">
        <a data-social-media-type="whatsapp" href={whatsappUrl} target="_blank" rel="nofollow">
          <Whatsapp text={translate(publisherName, "share")} />
        </a>
      </li>
      <li className="telegram-share-icon">
        <a
          href={`tg://msg_url?url=${encodeURIComponent(fullUrl)}&text=${encodeURIComponent(title)}`}
          target="_blank"
          rel="nofollow"
        >
          <Telegram text={translate(publisherName, "share")} />
        </a>
      </li>
      <li styleName="messanger-hide" className="messanger-share-icon messanger-hide">
        <a
          href={`http://www.facebook.com/dialog/send?link=${encodeURIComponent(
            fullUrl
          )}&app_id=907794602598966&redirect_uri=https://www.thequint.com/`}
          target="_blank"
          rel="nofollow"
        >
          <Messanger text={translate(publisherName, "share")} />
        </a>
      </li>
      <li className="comment-share-icon">
        <Comment
          text={translate(publisherName, "comments")}
          className={publisherName === "quint-hindi" ? "" : "comment-wrapper"}
        />
      </li>
    </ul>
  );
};

SocialShareLinks.propTypes = {
  whatsappUrl: string,
  fbUrl: string,
  twitterUrl: string,
  title: string,
  url: string,
  publisherUrl: string,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(SocialShareLinks);
